import React, { useEffect } from "react";
import "./titleHeader.css";
import { RiArrowRightSLine } from "react-icons/ri";
import PropTypes from "prop-types";
import AOS from "aos";
import "aos/dist/aos.css";

const TitleHeader = React.memo(
  ({
    headerMargin,
    smallTitleFontWeight,
    isSmallTitleVisible,
    smallTitle,
    smallTitleColor,
    title,
    titleColor,
    titleNormal,
    btnTitle,
    btnTextColor,
    btnBgColor,
    btnIconColor,
    btnIconBgColor,
    isBtnVisible,
    isRightArrowVisible,
    rightArrowBgColor,
    rightArrowIconColor,
    isTitleBottomLine,
  }) => {
    // Extract the first character and the rest of the title
    const firstCharacter = title?.charAt(0) || "";
    const remainingTitle = title?.slice(1) || "";

    useEffect(() => {
      const isDesktop = window.innerWidth >= 768; // Define desktop breakpoint

      if (isDesktop) {
        AOS.init({
          duration: 1500, // Animation duration
          once: true, // Trigger animations only once
          mirror: false, // No repeating on scroll up
          offset: 0, // Offset for animations
        });

        AOS.refresh();
      } else {
        // Clean up AOS animations on mobile
        const animatedElements = document.querySelectorAll("[data-aos]");
        animatedElements.forEach((element) => {
          element.classList.remove("aos-animate");
          element.removeAttribute("data-aos"); // Disable AOS attributes on mobile
        });
      }
    }, []);

    return (
      <header
        className="TitleHeaderMain"
        style={{ marginBottom: headerMargin }}
      >
        <div className="titleHeaderLeftCol" data-aos="fade-right">
          {isSmallTitleVisible === "Y" && (
            <span
              style={{
                color: smallTitleColor,
                fontWeight: smallTitleFontWeight,
              }}
            >
              {smallTitle}
            </span>
          )}
          {isBtnVisible === "Y" && (
            <button
              style={{ backgroundColor: btnBgColor, color: btnTextColor }}
            >
              {btnTitle}
              <div style={{ backgroundColor: btnIconBgColor }}>
                {/* <RiArrowRightDownFill style={{ color: btnIconColor }} /> */}
                <img
                  src={require("../../assets/images/logo-small.png")}
                  alt="surftech system"
                  className="img-fluid"
                  title="surftech system"
                />
              </div>
            </button>
          )}
          {titleNormal === "Y" && (
            <h4
              className={
                isTitleBottomLine === "Y" && "titleHeaderTitleBottomLine"
              }
              style={{ color: titleColor }}
            >
              <span className="titleFirstCharacter">{firstCharacter}</span>
              {remainingTitle}
            </h4>
          )}
          {titleNormal !== "Y" && (
            <h3
              className={`
                ${isTitleBottomLine === "Y" && "titleHeaderTitleBottomLine"}
               titleNormal
              `}
              style={{ color: titleColor }}
            >
              <span className="titleFirstCharacter">{firstCharacter}</span>
              {remainingTitle}
            </h3>
          )}
        </div>
        {isRightArrowVisible === "Y" && (
          <div className="titleHeaderRightCol">
            <div style={{ backgroundColor: rightArrowBgColor }}>
              <RiArrowRightSLine style={{ color: rightArrowIconColor }} />
            </div>
          </div>
        )}
      </header>
    );
  }
);

TitleHeader.displayName = "TitleHeader";

TitleHeader.propTypes = {
  headerMargin: PropTypes.string,
  title: PropTypes.string,
  titleColor: PropTypes.string,
  btnTitle: PropTypes.string,
  btnTextColor: PropTypes.string,
  btnBgColor: PropTypes.string,
  btnIconColor: PropTypes.string,
  btnIconBgColor: PropTypes.string,
  isBtnVisible: PropTypes.string,
  isRightArrowVisible: PropTypes.string,
  rightArrowBgColor: PropTypes.string,
  rightArrowIconColor: PropTypes.string,
  isTitleBottomLine: PropTypes.string,
  isSmallTitleVisible: PropTypes.string,
  smallTitle: PropTypes.string,
  smallTitleColor: PropTypes.string,
  smallTitleFontWeight: PropTypes.string,
};

export default TitleHeader;
